import styled from '@emotion/styled';
import Dialog from '../../../utils/utilities/Dialog';

import EditIcon from '@mui/icons-material/Edit';
import ClearAllRoundedIcon from '@mui/icons-material/ClearAllRounded';

import { IconButton, Tooltip, Button, Card, CardContent } from '@mui/material';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Formik, Form } from 'formik';

import Stages from '../../Services/Components/Stages';

import useFormDialog from '../../../hooks/useFormDialog';

import { modifyStages } from '../apiService';

import useSnackbarStore from '../../../store/snackbar';
import { BasicFlex } from '../../../utils/Common';

import PrepStage from './PrepStage';

const StageFormContainer = styled.div`
  margin: 0 1rem;
`;

const SubmitButton = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
`

const CompletedStages = styled.div`
  /* border: 1px solid ${props => props.theme.colors.border};
  border-radius: 5px; */
  margin-bottom: 2.5rem;
`;

const CompletedStagesTitle = styled.div`
  background-color: ${props => props.theme.colors.lightBg};
  padding: .5rem 1rem;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.colors.border};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
`;

const EditStageForm = ({ stages, ticket }) => {

  const { handleClose } = useFormDialog() || {};

  const completedStages = stages?.filter(stage => stage.received_at);

  let editableStages = stages?.filter(stage => !stage.received_at);

  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  const queryClient = useQueryClient();

  const { mutate: updateStageMutation } = useMutation({
    mutationFn: modifyStages,
    onSuccess: () => {
      showSnackbar('Updated successfully!', 'success');
      queryClient.invalidateQueries({ queryKey: ['service_tickets'] });
      if (handleClose) handleClose();
    },
    onError: (e) => {
      showSnackbar('Failed to update!', 'error');
    }
  })

  const handleSubmit = (values) => {
    let updated = [...completedStages, ...values.prep_stages].map(stage => {
      delete stage.key;
      return stage;
    });
    updateStageMutation({ service_ticket_id: ticket?.service_ticket_id, prep_stages: updated });
    // if (handleClose) handleClose();
  }

  return (
    <Formik
      initialValues={{ prep_stages: editableStages || [] }}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formikBag) => (
      <Form>
        {completedStages?.length ? <CompletedStages>
          <CompletedStagesTitle>Completed Stages</CompletedStagesTitle>
          <BasicFlex dir="column" gap="1rem" my="1rem">
           {completedStages?.map((stage, index) => (
             <PrepStage key={index} stage={stage} />
           ))}
          </BasicFlex>
        </CompletedStages> : null}
        <Stages />
        <SubmitButton>
          <Button type="submit" variant="contained" startIcon={<ClearAllRoundedIcon />}>Save Stages</Button>
        </SubmitButton>
      </Form>
      )}
    </Formik>
  )
};


const EditStage = ({ stages, ticket }) => {
  return (
    <Dialog
      title="Edit Stages"
      toggle={
        <Tooltip title="Edit Stages"><IconButton size="small"><EditIcon color="basic" /></IconButton></Tooltip>
      }
      size="md"
      useForm={true}
    >
      <StageFormContainer>
        <EditStageForm stages={stages} ticket={ticket} />
      </StageFormContainer>
    </Dialog>
  )
};

export default EditStage;